var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['base-input', { 'invalid': _vm.hasError }]},[_c('label',[_vm._v(_vm._s(_vm.labelText))]),_c('input',{ref:"input",attrs:{"name":_vm.name,"type":_vm.type},on:{"input":_vm.handleInput}})])}
var staticRenderFns = []

export { render, staticRenderFns }